export const SAVE = 'Sauvegarder';
export const SAVE_WITHOUT_EDITED = 'Sauvegarder sans modifier la date';
